import React, { useEffect, useRef } from "react";

const AccordionItem = ({
  id,
  item,
  index,
  isActive,
  onClick,
  headerChildren,
  bodyChildren,
  bodyOverflow = "",
  overrideStyle = {},
}) => {
  const contentRef = useRef(null);

  const updateBodyHeight = (isActive) => {
    if (contentRef && contentRef.current) {
      if (isActive) {
        contentRef.current.style.maxHeight = `${contentRef.current.scrollHeight}px`;
        contentRef.current.style.opacity = "1";
        contentRef.current.style.pointerEvents = "auto";
      } else {
        contentRef.current.style.maxHeight = "0px";
        contentRef.current.style.opacity = "0";
        contentRef.current.style.pointerEvents = "none";
      }
    }
  };

  useEffect(() => {
    updateBodyHeight(isActive);
  }, [isActive, item]);

  useEffect(() => {
    const handleResize = () => {
      if (isActive) {
        updateBodyHeight(isActive);
      }
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [isActive]);

  return (
    <div id={id} className="border rounded-md">
      <div onClick={onClick} className="relative cursor-pointer">
        {headerChildren({ item, index, isActive })}
        <div className="absolute right-2 top-1/2 -translate-y-1/2 flex justify-center items-center">
          <svg
            className={`w-6 h-6 transition-transform duration-500 ease-in-out transform ${
              isActive ? "rotate-180" : ""
            }`}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polyline points="6 9 12 15 18 9"></polyline>
          </svg>
        </div>
      </div>
      <div
        ref={contentRef}
        className={`transition-max-height duration-500 ease-in-out ${bodyOverflow}`}
        style={{
          maxHeight: isActive ? `${contentRef?.current?.scrollHeight}px` : "0px",
        }}
      >
        <div className="p-4">{bodyChildren({ item, index })}</div>
      </div>
    </div>
  );
};

export default AccordionItem;
